/**
 * platform_lead_service.js
 *
 * Service frontend para chamar as Cloud Functions callables do CRM B2B.
 * Todas as chamadas são feitas via httpsCallable.
 */

import { httpsCallable, getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getApp } from "firebase/app";
import "./firebase"; // garante que o firebase foi inicializado

const platformFunctions = getFunctions(getApp(), "southamerica-east1");

if (process.env.REACT_APP_USE_EMULATOR === "true") {
    try {
        connectFunctionsEmulator(platformFunctions, "127.0.0.1", 5001);
    } catch (e) {
        // Ignora erro se já estiver conectado
    }
}

/**
 * Lista todos os leads B2B cadastrados na plataforma com filtros aplicados.
 */
export const listCrmLeads = async ({ page = 1, pageSize = 25, filters = {} } = {}) => {
    const fn = httpsCallable(platformFunctions, "platformListCrmLeads");
    const result = await fn({ page, pageSize, filters });
    return result.data;
};

/**
 * Move o estágio (coluna) do lead B2B no pipeline.
 */
export const moveLeadToStage = async ({ idTenant, targetStage, notes = "" }) => {
    const fn = httpsCallable(platformFunctions, "platformMoveLeadToStage");
    const result = await fn({ idTenant, targetStage, notes });
    return result.data;
};

/**
 * Registra uma tentativa de contato ou resultado de negociação com o lead.
 */
export const registerLeadOutcome = async ({ idTenant, outcome, notes = "", channel = "whatsapp", lossReason = null }) => {
    const fn = httpsCallable(platformFunctions, "platformRegisterLeadOutcome");
    const result = await fn({ idTenant, outcome, notes, channel, lossReason });
    return result.data;
};

/**
 * Atribui ou altera o consultor responsável pelo lead.
 */
export const assignLeadConsultant = async ({ idTenant, consultant }) => {
    const fn = httpsCallable(platformFunctions, "platformAssignLeadConsultant");
    const result = await fn({ idTenant, consultant });
    return result.data;
};

/**
 * Obtém detalhes de um lead e sua timeline de interações.
 */
export const getLeadDetail = async (idTenant) => {
    const fn = httpsCallable(platformFunctions, "platformGetLeadDetail");
    const result = await fn({ idTenant });
    return result.data;
};

/**
 * Reabre um lead perdido/frio/arquivado para um novo ciclo de engajamento.
 * Move o stage para 'contacted', incrementa reEngagementCount e preserva histórico.
 */
export const reopenLead = async ({ idTenant, reopenReason, notes = "" }) => {
    const fn = httpsCallable(platformFunctions, "platformReopenLead");
    const result = await fn({ idTenant, reopenReason, notes });
    return result.data;
};

/**
 * Arquiva manualmente um lead — remove do Kanban principal sem deletar.
 * isArchived = true, archiveReason = 'manual'.
 */
export const archiveLead = async ({ idTenant }) => {
    const fn = httpsCallable(platformFunctions, "platformArchiveLead");
    const result = await fn({ idTenant });
    return result.data;
};
